import { defineComponent as _defineComponent } from 'vue'
import { computed, inject, onBeforeUnmount, onMounted, ref } from "vue";
import router from "@/router";
import { useUserStore } from "@/stores/userStore";
import {
  PROVIDE_KEY_SHOW_TOAST_MESSAGE,
  RankCode,
  ShowToastMessage,
} from "@/types";
import NavigationBar from "@/components/shared/NavigationBar.vue";
import Page from "@/components/shared/Page.vue";
import { useServiceStore } from "@/stores/serviceStore";
import { PROVIDE_KEY_SHOW_ERROR_MODAL } from "@/types";
import { ShowErrorModal } from "@/types";
import DynamicEditMyInfoForm from "@/components/mypage/DynamicEditMyInfoForm.vue";
import { useRoute } from "vue-router";
import { IUserInfo } from "@/domain/entities/user";
import { handleAuthValue } from "@/utils/handleAuthValue";
import Modal from "@/components/shared/modal/base/Modal.vue";
import ScrollTopControl from "@/components/shared/ScrollTopControl.vue";


const __default__ = {
  name: "EditMyInfo",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props, { expose: __expose }) {
  __expose();

const showToastMessage = inject(
  PROVIDE_KEY_SHOW_TOAST_MESSAGE
) as ShowToastMessage;
const showErrorModal = inject(PROVIDE_KEY_SHOW_ERROR_MODAL) as ShowErrorModal;

const route = useRoute();
const scrollContainer = ref<HTMLElement>();

const { maskingUserphone, eziokCertAuthValueEnc } =
  handleAuthValue().getAuthValueFromSessionStorage();
handleAuthValue().removeAuthValueFromSessionStorage();

const serviceStore = useServiceStore();
const userStore = useUserStore();

const userInfo = computed((): IUserInfo | undefined => {
  if (maskingUserphone?.length) {
    return { ...userStore.userInfo, phone: maskingUserphone } as IUserInfo;
  }
  return userStore.userInfo;
});
const rankCode = computed(() => userInfo.value?.rankCode ?? RankCode.NONE);

const showEditMyInfo = () => {
  serviceStore.initSignupFields(rankCode.value);
};

const goToBack = () => {
  route.meta.willGoBack = true;
  router.back();
};

// 사용자 정보 수정하기
const editMyInfo = async (
  passwordValues: Record<string, any>,
  editedValues: Record<string, any>
) => {
  const isSuccessChangePassword = await changePassword(passwordValues);
  if (!isSuccessChangePassword) return;

  const eidtedMyInfoValues = eziokCertAuthValueEnc?.length
    ? { ...editedValues, phone: maskingUserphone, eziokCertAuthValueEnc }
    : editedValues;
  const changeMyInfoResult = await userStore.changeMyInfo(eidtedMyInfoValues);
  if (!changeMyInfoResult.isSuccess) {
    showErrorModal(
      "회원정보 수정 실패",
      "회원정보 수정에 오류가 발생했습니다.",
      changeMyInfoResult.resultCode,
      changeMyInfoResult.errorTime
    );
    return;
  }

  await userStore.getUserInfo();

  goToBack();
  showToastMessage("회원정보 수정이 완료되었습니다.", 3000, 350);
};

const changePassword = async (passwordValues: Record<string, any>) => {
  // 비밀번호 변경을 안하는 경우 처리
  const hasEmptyValue = !!Object.values(passwordValues).filter(
    (value) => !value
  ).length;
  if (!Object.keys(passwordValues).length || hasEmptyValue) return true;

  const changePasswordResult = await userStore.changePassword(passwordValues);
  if (!changePasswordResult.isSuccess) {
    const errorMessage =
      changePasswordResult.resultCode === 401000010
        ? "비밀번호가 일치하지 않습니다."
        : changePasswordResult.errorMessage;
    showErrorModal(
      "회원정보 수정 오류",
      errorMessage,
      changePasswordResult.resultCode,
      changePasswordResult.errorTime
    );
  }
  return changePasswordResult.isSuccess;
};

/** 유저 정보 가져오기 */
const getUserInfo = async () => {
  const userInfoResult = await userStore.getUserInfo();
  if (!userInfoResult.isSuccess) {
    showErrorModal(
      "사용자 정보 오류",
      userInfoResult.errorMessage,
      userInfoResult.resultCode,
      userInfoResult.errorTime
    );
  }
};

/** 뒤로가기 확인 모달 */
const shouldShowConfirmGoBackModal = ref(false);
const toggleShowConfirmGoBackModal = (show: boolean) => {
  shouldShowConfirmGoBackModal.value = show;
};

onMounted(async () => {
  if (!userInfo.value) {
    await getUserInfo();
  }

  showEditMyInfo();
  route.meta.onBackHandlerList.push(() => toggleShowConfirmGoBackModal(true));
});

onBeforeUnmount(() => {});

const __returned__ = { showToastMessage, showErrorModal, route, scrollContainer, maskingUserphone, eziokCertAuthValueEnc, serviceStore, userStore, userInfo, rankCode, showEditMyInfo, goToBack, editMyInfo, changePassword, getUserInfo, shouldShowConfirmGoBackModal, toggleShowConfirmGoBackModal, NavigationBar, Page, DynamicEditMyInfoForm, Modal, ScrollTopControl }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})